<template>
  <div>
    <div>
      <span class="icon hero-icon hero-icon-add">{{$t("UE.ue_traffic")}}</span>
      <UeChart ref='ueChart'></UeChart>
    </div>
    <div>
      <span class="icon hero-icon hero-icon-add">{{$t("UE.ue_camera")}}</span>
      <UeCameraTable ref='ueCameraTable'></UeCameraTable>
    </div>
  </div>
</template>
<script>
import UeChart from './UeChart';
import UeCameraTable from './UeCameraTable';

export default {
  name: 'UeDetailDialog',
  components: {
    UeChart,
    UeCameraTable
  },
  data() {
    return {

    };
  }
};
</script>
